import { useQuery } from "@apollo/client";
import { CATEGORY } from "../categories.queries";

import {
  CategoryQuery,
  CategoryQueryVariables,
} from "../../../__generated__/CategoryQuery";

export const useCategory = (id: number) => {
  return useQuery<CategoryQuery, CategoryQueryVariables>(CATEGORY, {
    variables: { id },
  });
};
